import { ColumnDef } from '@tanstack/table-core';

import { Tooltip } from '@mui/material';
import { Article } from '@mui/icons-material';

import { secondsToDhms } from '../Format';
import { dateHeader, formatCellDate } from './timeModeCell';

import { ClosestReaderLog } from '../../types/ClosestReaderLog';

import { linkTo } from '../linkTo';

export const makeClosestReaderLogColumns = (onInfoClick): ColumnDef<ClosestReaderLog>[] => {
  return [
    {
      header: 'Id',
      accessorKey: 'scanSessionId',
      enableColumnFilter: true,
      size: 50,
      cell: ({ row }) => (
        <Tooltip title='Show Closest Reader Log' placement='right' style={{ cursor: 'pointer' }}>
          <Article style={{ height: '0.7em' }} color='action' cursor='pointer' onClick={() => onInfoClick(row.original.closestReaderLog ?? '')} />
        </Tooltip>
      ),
    },
    {
      header: 'IMEI',
      accessorKey: 'newImei',
      size: 160,
      cell: ({ row }) => linkTo('/readers', row.original.newImei ?? '', row.original.newImei ?? ''),
    },
    {
      header: 'Reader Name',
      accessorKey: 'readerName',
      size: 180,
      cell: ({ row }) => row.original?.closestReader?.readerName || '-',
    },
    {
      header: 'Status',
      accessorKey: 'isActive',
      size: 200,
      cell: ({ row }) => {
        const isActive = row.original?.closestReader?.isActive;
        const status = isActive ? 'Active' : 'Inactive';
        return <span style={{ color: isActive ? 'green' : 'red' }}>{status}</span>;
      },
    },
    {
      header: 'Total Sighting',
      accessorKey: 'totalSightings',
      size: 200,
      cell: ({ row }) => row.original.totalSightings || '-',
    },
    {
      header: 'Facility Name',
      accessorKey: 'closestFacilityName',
      size: 180,
      cell: ({ row }) => row.original.closestFacilityName || '-',
    },
    {
      header: 'Station',
      accessorKey: 'stationIataCode',
      size: 100,
      cell: ({ row }) => row.original.stationIataCode || '-',
    },
    {
      header: 'Report Interval',
      accessorKey: 'reportInterval',
      size: 100,
      cell: ({ row }) => (row.original?.closestReader?.reportInterval ? secondsToDhms(row.original?.closestReader?.reportInterval) : '-'),
    },
    {
      header: dateHeader('Last Seen'),
      accessorKey: 'lastSeenDateTime',
      size: 150,
      cell: ({ row, table }) => {
        try {
          return row.original?.closestReader?.lastSeenDateTime ? formatCellDate(table, row.original?.closestReader?.lastSeenDateTime) : '-';
        } catch {
          return '-';
        }
      },
    },
    {
      header: dateHeader('Last Time Of Report'),
      accessorKey: 'lastTimeOfReport',
      size: 150,
      cell: ({ row, table }) => {
        try {
          return row.original?.closestReader?.lastTimeOfReport ? formatCellDate(table, row.original?.closestReader?.lastTimeOfReport) : '-';
        } catch {
          return '-';
        }
      },
    },
    {
      header: dateHeader('Logged Date Time'),
      accessorKey: 'loggedDateTime',
      size: 150,
      cell: ({ row, table }) => {
        try {
          return row.original?.loggedDateTime ? formatCellDate(table, row.original?.loggedDateTime) : '-';
        } catch {
          return '-';
        }
      },
    },
    {
      header: dateHeader('Revisit Date Time'),
      accessorKey: 'revisitDateTime',
      size: 150,
      cell: ({ row, table }) => {
        try {
          return row.original?.revisitDateTime ? formatCellDate(table, row.original?.revisitDateTime) : '-';
        } catch {
          return '-';
        }
      },
    },
  ];
};
